import { observable, action } from 'mobx';

import config from 'config';
import postStore from 'modules/cms/stores/post'
import { LOADING, LOADED } from 'stores/BaseStore';
import HttpClient from 'utils/httpclient';

import { buildEntity, loadContents } from './base-store';

class ReportsSessionStore {
  @observable status = LOADED;
  @observable data = {};

  async loadPostContentTypes() {
    this.postContentTypes = await loadContents();
  }

  get isLoading() {
    return this.status === LOADING
  }

  get postParams() {
    const self = this
    return {
      report: false,
      get content_type() {
        return self.postContentTypes
      },
    }
  }
  post = buildEntity(postStore, {
    params: this.postParams,
    extraKeys: ["content_type"],
    labelFn: ({ value, label, content_type }) => `[#${value}][${content_type}] - ${label}`,
  })

  @action getData(queryParams) {
    this.status = LOADING
    const params = { ...queryParams };

    params.startDate = params.startDate.format()
    params.endDate = params.endDate.format()
    const site = JSON.parse(localStorage.getItem('site'));
    params.siteId = site.id;

    return HttpClient.get(`${config.api}/reports/session`, { params }).then(({ data }) => {
      this.data = data || {}
      this.status = LOADED
      return data
    })
  }
}

export default new ReportsSessionStore();
